/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceUnitType } from './PriceUnitType';
import {
    PriceUnitTypeFromJSON,
    PriceUnitTypeFromJSONTyped,
    PriceUnitTypeToJSON,
    PriceUnitTypeToJSONTyped,
} from './PriceUnitType';

/**
 * 
 * @export
 * @interface PriceUnitDto
 */
export interface PriceUnitDto {
    /**
     * 
     * @type {number}
     * @memberof PriceUnitDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PriceUnitDto
     */
    name: string | null;
    /**
     * 
     * @type {PriceUnitType}
     * @memberof PriceUnitDto
     */
    type: PriceUnitType;
}



/**
 * Check if a given object implements the PriceUnitDto interface.
 */
export function instanceOfPriceUnitDto(value: object): value is PriceUnitDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PriceUnitDtoFromJSON(json: any): PriceUnitDto {
    return PriceUnitDtoFromJSONTyped(json, false);
}

export function PriceUnitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceUnitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'type': PriceUnitTypeFromJSON(json['type']),
    };
}

export function PriceUnitDtoToJSON(json: any): PriceUnitDto {
    return PriceUnitDtoToJSONTyped(json, false);
}

export function PriceUnitDtoToJSONTyped(value?: PriceUnitDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': PriceUnitTypeToJSON(value['type']),
    };
}

